import { createSlice } from "@reduxjs/toolkit";
const DataSlice = createSlice({
    name:"Maindata",
    initialState:{
        HomeData:null,
        AboutData:null,
        UTMData: null
    },
    reducers:{
        addData:(state,actions)=>{
           state.HomeData =  actions.payload
        },
        addAboutData:(state,actions)=>{
            state.AboutData =  actions.payload
        },
        addUTMData:(state,actions)=>{
            state.UTMData =  actions.payload
        }
    }
})

export const {addData , addAboutData, addUTMData} = DataSlice.actions;

export default DataSlice.reducer;